import { ChartTile } from "web/components/Tiles"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import TileChartSettingsModalWrapper from "./TileChartSettingsModalWrapper"

export default function ChartTileWrapper({
  canEdit,
  isTemplate,
  overview,
  tileFetchParams,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileChartSettingsModalWrapper,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  const emptyMessage = "There is no data for this Chart."

  return (
    <ChartTile
      canEdit={canEdit}
      emptyMessage={emptyMessage}
      isTemplate={isTemplate}
      tile={tile}
      tileSettingsModal={tileSettingsModal}
    />
  )
}
